import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import FieldSet from '../../../../fieldset/FieldSet';
import Grid from '../../../../grid/Grid';
import VerticalLabelList from '../../../../label/VerticalLabelList';

class IVRConversation extends React.Component {
  constructor(props) {
    super(props);

    this.keyExclusions = [ 'mongoId', 'className', ];
  }

  formatBills(bills = []) {
    return bills.map((value) => {
      const ref = { ...value, };
      ref.amount = value.amount ? value.amount.amount : '';
      return ref;
    });
  }

  render() {
    const { conversation, } = this.props;

    const itemsToShow = VerticalLabelList.toList({
      'Call Id': conversation.callId,
      'Phone Number': conversation.phoneNumber,
      'Customer Id': conversation.customerId,
      'Service Offering Id': conversation.serviceOfferingId,
      'App Key': conversation.appKey,
      'External Account Id': conversation.externalAccountId,
      'Amount Entered': conversation.amount ? conversation.amount.amount : '',
      'Payment Type': conversation.paymentType,
      'Created At': conversation.createdAt,
      'Updated At': conversation.updatedAt,
      'Confirmation Number': conversation.confirmationNumber,
      'Transaction Id': conversation.transactionId,
      'Is Prepay?': conversation.prepay,
      Id: conversation.id,
    });

    if (conversation.bills == null || conversation.bills.length === 0) {
      conversation.bills = [
        {
          billId: conversation.billId,
          amount: conversation.amount,
        },
      ];
    }

    const billModel = Grid.toModelFromList(conversation.bills, {
      headerFormatter: value => _.startCase(value.header),
    });

    const supportModel = Grid.toModelFromList(conversation.supportRedirects, {
      headerFormatter: value => _.startCase(value.header),
    });

    return (
      <>
        <FieldSet title="Conversation Summary" style={{ height: '100%', fontSize: '20px', }}>
          <VerticalLabelList items={itemsToShow} exclusions={this.keyExclusions} />
        </FieldSet>
        <FieldSet title="Bills Paid">
          <Grid
            headers={billModel.headers}
            rows={billModel.format(this.formatBills(conversation.bills))}
          />
        </FieldSet>
        <FieldSet title="Support Redirects">
          <Grid
            headers={supportModel.headers}
            rows={supportModel.format(conversation.supportRedirects)}
          />
        </FieldSet>
      </>
    );
  }
}

IVRConversation.propTypes = {
  conversation: PropTypes.instanceOf(Object).isRequired,
};

export default IVRConversation;
